import React from "react";
import "./Policies.css";

function Privacy() {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>

      <div className="policy-section">
        <h3>Welcome to ATLAS TRAVEL HOUSE Journey</h3>
        <p>
          ATLAS TRAVEL HOUSE (“us”, “we”, or “our”) operates
          www.atlastravelshouse.com (hereinafter referred to as “Service”). Our
          Privacy Policy governs your visit to www.atlastravelshouse.com, and
          explains how we collect, safeguard and disclose information that
          results from your use of our Service. We use your data to provide and
          improve Service. By using Service, you agree to the collection and use
          of information in accordance with this policy. Unless otherwise
          defined in this Privacy Policy, the terms used in this Privacy Policy
          have the same meanings as in our Terms and Conditions. Our Terms and
          Conditions (“Terms”) govern all use of our Service and together with
          the Privacy Policy constitutes your agreement with us (“agreement”).
        </p>
        <p>
          Definitions SERVICE means the www.atlastravelshouse.com website
          operated by ATLAS TRAVEL HOUSE Pvt Ltd. PERSONAL DATA means data about
          a living individual who can be identified from that data (or from
          those and other information either in our possession or likely to come
          into our possession). USAGE DATA is data collected automatically
          either generated by the use of Service or from Service infrastructure
          itself (for example, the duration of a page visit). COOKIES are small
          files stored on your device (computer or mobile device). DATA
          CONTROLLER means a natural or legal person who (either alone or
          jointly or in common with other persons) determines the purposes for
          which and the manner in which any personal data are, or are to be,
          processed. For the purpose of this Privacy Policy, we are a Data
          Controller of your data. DATA PROCESSORS (OR SERVICE PROVIDERS) means
          any natural or legal person who processes the data on behalf of the
          Data Controller. We may use the services of various Service Providers
          in order to process your data more effectively. DATA SUBJECT is any
          living individual who is the subject of Personal Data. THE USER is the
          individual using our Service. The User corresponds to the Data
          Subject, who is the subject of Personal Data.{" "}
        </p>

        <p>
          Information Collection and Use We collect several different types of
          information for various purposes to provide and improve our Service to
          you.
        </p>

        <p>
          Types of Data Collected Personal Data While using our Service, we may
          ask you to provide us with certain personally identifiable information
          that can be used to contact or identify you (“Personal Data”).
          Personally identifiable information may include, but is not limited
          to: 0.1. Email address 0.2. First name and last name 0.3. Phone number
          0.4. Address, Country, State, Province, ZIP/Postal code, City 0.5.
          Cookies and Usage Data We may use your Personal Data to contact you
          with newsletters, marketing or promotional materials and other
          information that may be of interest to you. You may opt out of
          receiving any, or all, of these communications from us by following
          the unsubscribe link. Usage Data We may also collect information that
          your browser sends whenever you visit our Service or when you access
          Service by or through any device (“Usage Data”). This Usage Data may
          include information such as your computer’s Internet Protocol address
          (e.g. IP address), browser type, browser version, the pages of our
          Service that you visit, the time and date of your visit, the time
          spent on those pages, unique device identifiers and other diagnostic
          data. When you access Service with a device, this Usage Data may
          include information such as the type of device you use, your device
          unique ID, the IP address of your device, your device operating
          system, the type of Internet browser you use, unique device
          identifiers and other diagnostic data. Location Data We may use and
          store information about your location if you give us permission to do
          so (“Location Data”). We use this data to provide features of our
          Service, to improve and customize our Service. You can enable or
          disable location services when you use our Service at any time by way
          of your device settings. Tracking Cookies Data We use cookies and
          similar tracking technologies to track the activity on our Service,
          and we hold certain information. Cookies are files with a small amount
          of data which may include an anonymous unique identifier. Cookies are
          sent to your browser from a website and stored on your device. Other
          tracking technologies are also used such as beacons, tags and scripts
          to collect and track information and to improve and analyze our
          Service. You can instruct your browser to refuse all cookies or to
          indicate when a cookie is being sent. However, if you do not accept
          cookies, you may not be able to use some portions of our Service.
          Examples of Cookies we use: 0.1. Session Cookies: We use Session
          Cookies to operate our Service. 0.2. Preference Cookies: We use
          Preference Cookies to remember your preferences and various settings.
          0.3. Security Cookies: We use Security Cookies for security purposes.
          0.4. Advertising Cookies: Advertising Cookies are used to serve you
          with advertisements that may be relevant to you and your interests.
          Other Data While using our Service, we may also collect the following
          information: sex, age, date of birth, place of birth, passport
          details, citizenship, registration at place of residence and actual
          address, telephone number (work, mobile), details of documents on
          education, qualification, professional training, employment
          agreements, non-disclosure agreements, information on bonuses and
          compensation, information on marital status, family members, social
          security (or other taxpayer identification) number, office location
          and other data.
        </p>
        <p>
          Use of Data ATLAS TRAVEL HOUSE uses the collected data for various
          purposes: 0.1. to provide and maintain our Service; 0.2. to notify you
          about changes to our Service; 0.3. to allow you to participate in
          interactive features of our Service when you choose to do so; 0.4. to
          provide customer support; 0.5. to gather analysis or valuable
          information so that we can improve our Service; 0.6. to monitor the
          usage of our Service; 0.7. to detect, prevent and address technical
          issues; 0.8. to fulfill any other purpose for which you provide it;
          0.9. to carry out our obligations and enforce our rights arising from
          any contracts entered into between you and us, including for billing
          and collection; 0.10. to provide you with notices about your account
          and/or subscription, including expiration and renewal notices,
          email-instructions, etc.; 0.11. to provide you with news, special
          offers and general information about other goods, services and events
          which we offer that are similar to those that you have already
          purchased or inquired about unless you have opted not to receive such
          information; 0.12. in any other way we may describe when you provide
          the information; 0.13. for any other purpose with your consent.
        </p>
        <p>
          Retention of Data We will retain your Personal Data only for as long
          as is necessary for the purposes set out in this Privacy Policy. We
          will retain and use your Personal Data to the extent necessary to
          comply with our legal obligations (for example, if we are required to
          retain your data to comply with applicable laws), resolve disputes,
          and enforce our legal agreements and policies. We will also retain
          Usage Data for internal analysis purposes. Usage Data is generally
          retained for a shorter period, except when this data is used to
          strengthen the security or to improve the functionality of our
          Service, or we are legally obligated to retain this data for longer
          time periods.
        </p>
      </div>

      <div className="policy-section">
        <h3>Transfer of Data</h3>
        <p>
          Your information, including Personal Data, may be transferred to – and
          maintained on – computers located outside of your state, province,
          country or other governmental jurisdiction where the data protection
          laws may differ from those of your jurisdiction. If you are located
          outside India and choose to provide information to us, please note
          that we transfer the data, including Personal Data, to India and
          process it there. Your consent to this Privacy Policy followed by your
          submission of such information represents your agreement to that
          transfer. ATLAS TRAVEL HOUSE will take all the steps reasonably
          necessary to ensure that your data is treated securely and in
          accordance with this Privacy Policy and no transfer of your Personal
          Data will take place to an organization or a country unless there are
          adequate controls in place including the security of your data and
          other personal information.
        </p>
      </div>

      <div className="policy-section">
        <h3>Disclosure of Data</h3>
        <p>
          We may disclose personal information that we collect, or you provide:
          0.1. Disclosure for Law Enforcement. Under certain circumstances, we
          may be required to disclose your Personal Data if required to do so by
          law or in response to valid requests by public authorities. 0.2.
          Business Transaction. If we or our subsidiaries are involved in a
          merger, acquisition or asset sale, your Personal Data may be
          transferred. 0.3. Other cases. We may disclose your information also:
          0.3.1. to our subsidiaries and affiliates; 0.3.2. to contractors,
          service providers, and other third parties we use to support our
          business; 0.3.3. to fulfill the purpose for which you provide it;
          0.3.4. for the purpose of including your company’s logo on our
          website; 0.3.5. for any other purpose disclosed by us when you provide
          the information; 0.3.6. with your consent in any other cases; 0.3.7.
          if we believe disclosure is necessary or appropriate to protect the
          rights, property, or safety of the Company, our customers, or others.
        </p>
      </div>
      <div className="policy-section">
        <h3>Security of Data</h3>
        <p>
          The security of your data is important to us but remember that no
          method of transmission over the Internet or method of electronic
          storage is 100% secure. While we strive to use commercially acceptable
          means to protect your Personal Data, we cannot guarantee its absolute
          security.
        </p>
      </div>
      <div className="policy-section">
        <h3>Service Providers</h3>
        <p>
          We may employ third party companies and individuals to facilitate our
          Service (“Service Providers”), provide Service on our behalf, perform
          Service-related services or assist us in analyzing how our Service is
          used. These third parties have access to your Personal Data only to
          perform these tasks on our behalf and are obligated not to disclose or
          use it for any other purpose. Analytics We may use third-party Service
          Providers to monitor and analyze the use of our Service.
        </p>
      </div>

      <div className="policy-section">
        <h3>CI/CD tools</h3>
        <p>
          We may use third-party Service Providers to automate the development
          process of our Service. We may use third-party Service Providers to
          show advertisements to you to help support and maintain our Service.
        </p>
      </div>

      <div className="policy-section">
        <h3>Behavioral Remarketing</h3>
        <p>
          We may use remarketing services to advertise on third party websites
          to you after you visited our Service. We and our third-party vendors
          use cookies to inform, optimize and serve ads based on your past
          visits to our Service.
        </p>
      </div>

      <div className="policy-section">
        <h3>Payments</h3>
        <p>
          We may provide paid products and/or services within the Service. In
          that case, we use third-party services for payment processing (e.g.
          payment processors). We will not store or collect your payment card
          details. That information is provided directly to our third-party
          payment processors, whose use of your personal information is governed
          by their Privacy Policy. These payment processors adhere to the
          standards set by PCI-DSS as managed by the PCI Security Standards
          Council, which is a joint effort of brands like Visa, Mastercard,
          American Express and Discover. PCI- DSS requirements help ensure the
          secure handling of payment information.
        </p>
      </div>
      <div className="policy-section">
        <h3>Links to Other Sites</h3>
        <p>
          Our Service may contain links to other sites that are not operated by
          us. If you click a third party link, you will be directed to that
          third party’s site. We strongly advise you to review the Privacy
          Policy of every site you visit. We have no control over and assume no
          responsibility for the content, privacy policies or practices of any
          third party sites or services.
        </p>
      </div>

      <div className="policy-section">
        <h3>For any Query</h3>
        <p>
          If you have any questions about this Privacy Policy, please contact us
          by email: sales@atlastravelshouse.com ATLAS TRAVEL HOUSE contains
          links to other websites. Please note that when you click on one of
          those links, you are entering another website for which ATLAS TRAVEL
          HOUSE has no responsibility. We advise you to read the privacy
          statements of all such sites, as they may be materially different. You
          are solely responsible for maintaining the secrecy of your Password &
          Credit/Debit Card numbers. We may disclose the member information if
          required to do so by the legal authorities. The user hereby consent
          expresses & agrees that he has read & fully understand the privacy
          policy of ATLAS TRAVEL HOUSE Journey. And the user further gives
          consent for the acceptance of terms & conditions. ATLAS TRAVEL HOUSE
          will not be liable to you or any other person. For any direct loss,
          damage cost or expense of any kind whatsoever caused from out of usage
          of this website.
        </p>
      </div>
    </div>
  );
}

export default Privacy;
